module.exports = __webpack_public_path__ + "img/01_maska_mazok_1.ed5d50a.svg";